<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.24903 30.3704C6.86542 28.9867 6.17361 28.2949 5.67888 27.4876C5.24025 26.7718 4.91701 25.9915 4.72104 25.1752C4.5 24.2545 4.5 23.2761 4.5 21.3194V17.3C4.5 12.8196 4.5 10.5794 5.37195 8.86808C6.13893 7.36278 7.36278 6.13893 8.86808 5.37195C10.5794 4.5 12.8196 4.5 17.3 4.5H21.3194C23.2761 4.5 24.2545 4.5 25.1752 4.72104C25.9915 4.91701 26.7718 5.24025 27.4876 5.67888C28.2949 6.17361 28.9867 6.86542 30.3704 8.24903L37.0607 14.9393C40.7823 18.661 42.6431 20.5218 43.3991 22.6438C44.1725 24.8144 44.1725 27.1856 43.3991 29.3562C42.6431 31.4782 40.7823 33.339 37.0607 37.0607C33.339 40.7823 31.4782 42.6431 29.3562 43.3991C27.1856 44.1725 24.8144 44.1725 22.6438 43.3991C20.5218 42.6431 18.661 40.7823 14.9393 37.0607L8.24903 30.3704ZM20 24C22.2091 24 24 22.2091 24 20C24 17.7909 22.2091 16 20 16C17.7909 16 16 17.7909 16 20C16 22.2091 17.7909 24 20 24Z"
      fill="#0D1017"
    />
  </svg>
</template>
<script>
export default {
  name: 'BrandIcon',
}
</script>
